module.exports = __webpack_public_path__ + "static/img/2025封面英文.5d171ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/2025封面英文.jpg
// module id = a6YX
// module chunks = 1